import * as React from 'react';
import { Typography, Paper, Button, Grid, Icon } from '@material-ui/core'
import { RouteComponentProps } from "react-router-dom";

interface IProps extends RouteComponentProps<{}> {
}

const SubscribeRequestConfirm = (props: IProps) => {
  const getReturnUrl = (): string => {
    if (props.location && props.location.state && props.location.state.requiredCommunity) {
      return props.location.state.requiredCommunity.returnUrl;
    }
    return process.env.REACT_APP_PUBLIC_WEBSITE_URL + "/en/market/our-marketplace/marketplace";
  }

  const getReturnText = () => {
    if (props.location && props.location.state && props.location.state.requiredCommunity) {
      return 'Back to community page';
    }
    return 'Back to marketplace'
  }


  return (
    <div style={{ textAlign: "center" }}>
      <Icon style={{ fontSize: 90, color: '#80c96e' }}>check_circle_outline</Icon>
      <div className="padding-bottom-24"/>
      <Paper className="padding-24" style={{ maxWidth: 550, display: "inline-block" }}>
        <Typography variant="display1" color="secondary" className="padding-bottom-24">
          Subscription requested
        </Typography>
        <Typography gutterBottom={true}>
          Your subscription has been requested.
        </Typography>
        <Typography gutterBottom={true} className="padding-bottom-24">
          We will send you an email once it's approved.
        </Typography>
        <Grid container={true} spacing={24} alignItems='center'>
          <Grid item={true}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => location.replace(getReturnUrl())}
            >
              {getReturnText()}
            </Button>
          </Grid>
          <Grid item={true}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => location.replace(process.env.REACT_APP_APPLICATION_ROOT as string + 'subscriptions')}

            >
              Check my subscriptions
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </div>
  )
}

export default SubscribeRequestConfirm;


// WEBPACK FOOTER //
// ./src/modules/subscription/pages/SubscribeRequestConfirm.tsx